import React, { useRef } from 'react';

const ImageProperties = ({ block, onUpdate }) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                onUpdate(block.id, { content: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <div className="space-y-4">
             {block.content && (
                <div className="mt-2">
                    <img src={block.content} alt="Aperçu" className="w-full rounded-md border" />
                </div>
            )}
            <button onClick={() => fileInputRef.current.click()} className="w-full p-2 bg-white border rounded text-center">
                Ajouter / Remplacer l'image
            </button>
            <input 
                type="file" 
                ref={fileInputRef}
                accept="image/*" 
                onChange={handleFileChange} 
                className="hidden" 
            />
            <div>
                <label className="flex items-center">
                    <input 
                        type="checkbox" 
                        checked={block.isFullWidth || false} 
                        onChange={(e) => onUpdate(block.id, { isFullWidth: e.target.checked })} 
                        className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                    <span className="ml-2 text-sm text-gray-700">Pleine largeur</span>
                </label>
            </div>
            <div className="pt-4 border-t">
                <label className="block text-sm font-medium">Marge haute ({block.paddingTop || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingTop || 0} onChange={(e) => onUpdate(block.id, { paddingTop: parseInt(e.target.value) })} className="w-full" />
            </div>
            <div>
                <label className="block text-sm font-medium">Marge basse ({block.paddingBottom || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingBottom || 0} onChange={(e) => onUpdate(block.id, { paddingBottom: parseInt(e.target.value) })} className="w-full" />
            </div>
             <div>
                <label className="block text-sm font-medium">Marges latérales ({block.paddingLeft || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingLeft || 0} onChange={(e) => {
                    const value = parseInt(e.target.value);
                    onUpdate(block.id, { paddingLeft: value, paddingRight: value });
                }} className="w-full" />
            </div>
        </div>
    );
};

export default ImageProperties;